import { Stack, Box } from '@vapor/material'
import { useEffect, useState } from 'react'
import ResettableTextField from './resettable-text-field'

export type ReservationPriceFieldProps = {
  initialTotalPerRoom: number
  onChange: (totalPerRoom: number) => void
}

export default function ReservationPriceField(props: ReservationPriceFieldProps) {
  const [totalPerRoom, setTotalPerRoom] = useState(props.initialTotalPerRoom)

  useEffect(() => props.onChange(totalPerRoom), [totalPerRoom])

  useEffect(() => {
    setTotalPerRoom(props.initialTotalPerRoom)
  }, [props.initialTotalPerRoom])

  return (
    <Stack direction="row" spacing={1}>
      <Box>
        <ResettableTextField changeOnBlur initialValue={props.initialTotalPerRoom} value={totalPerRoom} onChange={(newTotal) => setTotalPerRoom(newTotal ?? 0)} label="" resetPosition={'LEFT'} />
      </Box>
    </Stack>
  )
}
